import * as React from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  IconButton,
  Skeleton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ViewDetails from "../genericComponents/view-details/ViewDetails";
import { BasicProgram, ViewDetailsServices } from "@/app/classes/main";
import { SearchServiceMobileCard } from "./SearchServiceMobileCard";
import MaxServiceAlert from "../genericComponents/card/MaxServiceAlert";
import ViewDetailsRsOneContainer from "../genericComponents/view-details/ViewDetailsRsOneContainer";

interface SearchServicesProps {
  openSearchDialog: any;
  handleCloseSearchDialog: any;
  searchServiceList: any;
  setSearchServiceList: any;
  setServiceName: any;
  setReloadCartService: any;
}

const SearchServices: React.FC<SearchServicesProps> = ({
  openSearchDialog,
  handleCloseSearchDialog,
  searchServiceList,
  setSearchServiceList,
  setServiceName,
  setReloadCartService,
}) => {
  const [open, setOpen] = React.useState(false);
  const [viewDetails, setViewDetails] = React.useState<
    ViewDetailsServices | undefined
  >(undefined);
  const [reloadViewDetailsItem, setReloadViewDetailsItem] =
    React.useState(false);
  const [updateCard, setUpdateCard] = React.useState(false);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [openRsOneDetails, setOpenRsOneDetails] = React.useState(false);
  const [viewDetailsRsOneSid, setViewDetailsRsOneSid] = React.useState<
    number | undefined
  >(undefined);
  const theme = useTheme();
  const screenWidth = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpenViewDetailsRsOne = (basicProgram: BasicProgram) => {
    setOpenRsOneDetails(true);
    setViewDetailsRsOneSid(basicProgram?.id);
  };

  const handleOpenViewCart = (item: any) => {
    setOpen(true);
    setViewDetails(item);
  };

  const handleCloseDialog = () => {
    handleCloseSearchDialog();
    setSearchServiceList([]);
    setServiceName("");
  };

  return (
    <React.Fragment>
      <Dialog
        open={openSearchDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll={screenWidth ? "paper" : "body"}
        maxWidth="sm"
        fullWidth
        closeAfterTransition={false}
        sx={{
          display: { xs: "none", sm: "block" },
          "@media (max-width: 600px)": {
            "& .MuiDialog-paper": {
              width: "100%",
              height: "100%",
              maxHeight: "100%",
              maxWidth: "100%",
              margin: 0,
            },
          },
        }}
      >
        <Box
          sx={{
            overflow: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Box
            sx={{
              width: "-webkit-fill-available",
              textAlign: "end",
              position: "absolute",
            }}
          >
            <IconButton onClick={handleCloseDialog}>
              <CloseIcon sx={{ cursor: "pointer", color: "#15741a" }} />
            </IconButton>
          </Box>
          <Box sx={{ marginTop: "2.5rem" }}>
            {searchServiceList && searchServiceList.length > 0
              ? searchServiceList?.map((item: any) => (
                  <Box
                    key={item?.id}
                    onClick={() => handleOpenViewCart(item)}
                    sx={{
                      cursor: "pointer",
                      margin: "1rem",
                      boxShadow: "2px 2px 8px 2px rgba(0, 0, 0, 0.2)",
                      borderRadius: "0.5rem",
                    }}
                  >
                    <SearchServiceMobileCard
                      item={item}
                      setReloadViewDetailsItem={(value: any) => {
                        setReloadViewDetailsItem(value);
                        setReloadCartService();
                      }}
                      updateCard={updateCard}
                      setUpdateCard={() => setUpdateCard(false)}
                      setOpenMaxService={setOpenMaxService}
                      handleOpenViewDetailsRsOne={(item: any) =>
                        handleOpenViewDetailsRsOne(item)
                      }
                    />
                  </Box>
                ))
              : Array.from({ length: 5 }).map((_, i) => (
                  <Box
                    key={i}
                    sx={{
                      margin: "1rem",
                      boxShadow: "2px 2px 8px 2px rgba(0, 0, 0, 0.2)",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <Skeleton
                        variant="rounded"
                        sx={{
                          margin: "0.5rem",
                          width: "60px",
                          height: "60px",
                        }}
                      />
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            margin: "0.5rem",
                            width: "200px",
                            height: "25px",
                          }}
                        />
                        <Skeleton
                          variant="rectangular"
                          sx={{
                            margin: "0.5rem",
                            width: "200px",
                            height: "25px",
                          }}
                        />
                      </Box>
                    </Box>
                    <Skeleton
                      variant="rectangular"
                      sx={{
                        margin: "0.5rem",
                        width: "-webkit-fill-available",
                        height: "50px",
                      }}
                    />
                    <Skeleton
                      variant="rectangular"
                      sx={{
                        margin: "0.5rem",
                        width: "-webkit-fill-available",
                        height: "150px",
                      }}
                    />
                  </Box>
                ))}
          </Box>
        </Box>
      </Dialog>
      <ViewDetails
        open={open}
        setClose={() => setOpen(false)}
        imageUrl={viewDetails?.coverImage?.secureHttpPath}
        heading={viewDetails?.name}
        servicedDetails={viewDetails?.aboutList}
        descriptions={viewDetails?.descriptions}
        amount={viewDetails?.amount}
        min={viewDetails?.min}
        id={viewDetails?.id}
        cid={viewDetails?.cid}
        subHeading={viewDetails?.subHeading}
        mrp={viewDetails?.mrp}
        specialPrice={viewDetails?.specialPrice}
        specialMessage={viewDetails?.specialMessage}
        coin={viewDetails?.cashbackSalontymCoins}
        aboutList={viewDetails?.aboutList}
        serviceCharge={viewDetails?.serviceCharge}
        productCost={viewDetails?.productCost}
        reloadCartItemsFlag={() => {
          setUpdateCard(true), setReloadCartService();
        }}
        reloadViewDetailsItem={reloadViewDetailsItem}
        setReloadViewDetailsItem={() => {
          setReloadViewDetailsItem(false);
        }}
      />
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
      <ViewDetailsRsOneContainer
        open={openRsOneDetails}
        handleCloseStoreDialog={() => setOpenRsOneDetails(false)}
        viewDetailsRsOneSid={viewDetailsRsOneSid}
      />
    </React.Fragment>
  );
};

export default SearchServices;
